import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import V2SettingsIframe from '@aware/common/v2-settings-iframe';
import { replaceCancelButtonAction } from './helpers';

const CreateNewTestType = () => {
  const history = useHistory();
  const location = useLocation();

  // This should just refresh the page
  const redirectFn = () => {
    history.push('create-new-test-type');
  };

  return (
    <V2SettingsIframe
      iframeSrc="/aware/?embed=1&detailsSrc=manage/tests/newtesttype.aspx"
      title="Create New Test Type"
      key={location.key}
      onLoadCallback={iframe => replaceCancelButtonAction({ iframe, redirectFn })}
    />
  );
};

export default CreateNewTestType;
